import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap'

const Projects = () => {
  const [projects, setProjects] = useState(true)
  const [certificates, setCertificates] = useState(false)

  const showProjects = e => {
    setCertificates(false)
    setProjects(true)
  }
  const showCertificates = e => {
    setProjects(false)
    setCertificates(true)
  }

  const showing = {
    scale: '0.7',
    color: 'black',
    background: 'gray',
  }
  const hiding = {
    scale: '1',
    color: '#7cb342',
    background: 'transparent',
  }

  return (
    <div className='projects'>
      <div className='projects-certificate'>
        <button
          style={projects ? showing : hiding}
          onClick={e => showProjects(e)}
          className='projects-btn'
        >
          Projects
        </button>
        <button
          style={certificates ? showing : hiding}
          onClick={e => showCertificates(e)}
          className='certificates-btn'
        >
          Certificates
        </button>
      </div>

      <div className='pig-projects'>
        {projects && (
          <Carousel>
            <Carousel.Item>
              <a href='https://alwaradshop.herokuapp.com/' target='#'>
                <div className='img-overlay'>
                  <img
                    className='d-block'
                    src={require('../img/alwaradshop.png')}
                    alt='AlwaradShop'
                  />
                  <Carousel.Caption>
                    <h5>Click to see the project</h5>
                    <p>E-Commerce Shope.</p>
                  </Carousel.Caption>
                </div>
              </a>
            </Carousel.Item>
            <Carousel.Item>
              <a href='https://turksey.com/en/home/' target='#'>
                <div className='img-overlay'>
                  <img
                    className='d-block'
                    src={require('../img/turksey.png')}
                    alt='Turksey'
                  />
                  <Carousel.Caption>
                    <h5>Click to see the project</h5>
                    <p>turksey.com</p>
                  </Carousel.Caption>
                </div>
              </a>
            </Carousel.Item>
            <Carousel.Item>
              <a href='https://lucent-cascaron-6d0cce.netlify.app/' target='#'>
                <div className='img-overlay'>
                  <img
                    className='d-block'
                    src={require('../img/bbconnected.png')}
                    alt='BBConnected'
                  />
                  <Carousel.Caption>
                    <h5>Click to see the project</h5>
                    <p>Social/Business/Recruitment Project.</p>
                  </Carousel.Caption>
                </div>
              </a>
            </Carousel.Item>
            <Carousel.Item>
              <a href='https://githubuserfinder101.netlify.app/' target='#'>
                <div className='img-overlay'>
                  <img
                    className='d-block'
                    src={require('../img/githupfinder.png')}
                    alt='GithubFinder'
                  />

                  <Carousel.Caption>
                    <h5>Click to see the project</h5>
                    <p>Github Finder.</p>
                  </Carousel.Caption>
                </div>
              </a>
            </Carousel.Item>
            <Carousel.Item>
              <a href='../small_projects/movie_app/index.html' target='#'>
                <div className='img-overlay'>
                  <img
                    className='d-block'
                    src={require('../img/movie_app.png')}
                    alt='MovieReviewer'
                  />

                  <Carousel.Caption>
                    <h6>Not Uploaded</h6>
                    <p>See My Github For More Info</p>
                    <p>Movie Reviewer.</p>
                  </Carousel.Caption>
                </div>
              </a>
            </Carousel.Item>
          </Carousel>
        )}

        {/* -------------------------------------Certificates */}

        {certificates && (
          <Carousel>
            <Carousel.Item>
              <div className='img-overlay img-certificates'>
                <img
                  className='d-block'
                  src={require('../img/certificates/wbs.png')}
                  alt='AlwaradShop'
                />
                <Carousel.Caption>
                  <h5>WBS CODING SCHOOL</h5>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className='img-overlay img-certificates'>
                <img
                  className='d-block'
                  src={require('../img/certificates/turksey.png')}
                  alt='AlwaradShop'
                />
                <Carousel.Caption>
                  <h5>Trueksey.com</h5>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className='img-overlay img-certificates'>
                <img
                  className='d-block'
                  src={require('../img/certificates/c.png')}
                  alt='AlwaradShop'
                />
                <Carousel.Caption>
                  <h5>New Horizons C#</h5>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className='img-overlay img-certificates'>
                <img
                  className='d-block'
                  src={require('../img/certificates/cisco.png')}
                  alt='AlwaradShop'
                />
                <Carousel.Caption>
                  <h5>New Horizons CISCO</h5>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
            <Carousel.Item>
              <div className='img-overlay img-certificates'>
                <img
                  className='d-block'
                  src={require('../img/certificates/sql.png')}
                  alt='AlwaradShop'
                />
                <Carousel.Caption>
                  <h5>New Horizons MYSQL</h5>
                </Carousel.Caption>
              </div>
            </Carousel.Item>
          </Carousel>
        )}
      </div>

      <br />
      <a href='https://github.com/BasharAlwarad/50projects' target='#'>
        <button className='more-projects'>50 More Projects</button>
      </a>
    </div>
  )
}

export default Projects
